import Vue from 'vue';
import Router from 'vue-router';
import './componentHooks'; // <-- Needs to be first
import LoginComponent from './views/Login.vue';
import Home from './views/Home.vue';
import Bcp from './views/Bcp.vue';
import TaggingManager from './views/Tagging.vue';
import About from './views/About.vue';
import DashBoard from './views/ShimmyPlus/DashBoard.vue';
import PageOne from './views/ShimmyPlus/Page1.vue';
import PerformanceManager from './views/PerformanceManager.vue';
import PortfolioManager from './views/PortfolioManager.vue';
import PortfolioManagerDetails from './views/PortfolioManagerDetails.vue';
import DataQuality from './views/DataQuality.vue';
import ShimmyPlus from '@/views/ShimmyPlus/ShimmyPlus.vue';

Vue.use(Router);

export default new Router({
  // mode: 'abstract',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/dataquality',
      name: 'dataquality',
      component: DataQuality,
    },
    {
      path: '/bcp',
      name: 'bcp',
      component: Bcp,
    },
    {
      path: '/tagging',
      name: 'tagging',
      component: TaggingManager,
    },
    { name: 'shimmyplus', path: '/shimmyplus/:id', component: ShimmyPlus},
    {
      path: '/performance_manager',
      name: 'performance_manager',
      component: PerformanceManager,
    },
    {
      path: '/portfolio_manager',
      name: 'portfolio_manager',
      component: PortfolioManager,
    },
    {
      path: '/portfolio_manager_details/:id',
      name: 'portfolio_manager_details',
      component: PortfolioManagerDetails,
    },

    {
      path: '/login',
      name: 'login',
      component: LoginComponent,
    },
  ],
});
